import { createAction, props } from '@ngrx/store';
import { JwtTokens } from '@wizbii-utils/angular/jwt';

export const init = createAction('[Jwt] Init', props<{ jwtTokens: JwtTokens | null }>());
export const jwtSet = createAction('[Jwt] Set', props<{ jwtTokens: JwtTokens }>());
export const jwtSetSuccess = createAction('[Jwt] Set success', props<{ jwtTokens: JwtTokens }>());
export const jwtDelete = createAction('[Jwt] Delete');
export const jwtDeleteSuccess = createAction('[Jwt] Delete success');
export const jwtDeleteHard = createAction('[Jwt] Delete hard');
